import { useCallback } from 'react';
import {
  IBudgetsListResponse,
  approveBudgetAsManager,
  rejectBudgetAsManager,
} from '../../../api/fetchBudget';
import { BudgetRecipientEnum } from '../createAndEdit/types';
import { useNotification } from '../createAndEdit/hooks/useNotification';

interface IUseBudgetActionsParams {
  currentBudgetId: string | null;
  budgetsListResponse: IBudgetsListResponse | null;
  budgetFormData: any;
  userProfile: BudgetRecipientEnum | undefined;
  versionNumber?: number;
  onSuccess: () => void;
}

export const useBudgetActions = (params: IUseBudgetActionsParams) => {
  const { currentBudgetId, budgetsListResponse, budgetFormData, userProfile, versionNumber, onSuccess } = params;

  const handleAcceptBudget = useCallback(
    async (counterProposalValue?: number, counterProposalObs?: string, subscriptionBalanceToApply?: number) => {
      if (!currentBudgetId || !userProfile) {
        return;
      }

      if (userProfile === BudgetRecipientEnum.MANAGER) {
        const budgetItem = budgetsListResponse?.budgets.find(
          (item) => item.uuid === currentBudgetId,
        );
        const version = versionNumber || budgetItem?.lastVersionNumber || 1;
        const finalCounterProposalValue =
          counterProposalValue !== undefined
            ? counterProposalValue
            : budgetFormData?.counterProposalValue;
        const finalCounterProposalObs =
          counterProposalObs !== undefined
            ? counterProposalObs
            : budgetFormData?.counterProposalObs;

        try {
          const result = await approveBudgetAsManager(
            currentBudgetId,
            version,
            finalCounterProposalValue,
            finalCounterProposalObs,
            subscriptionBalanceToApply
          );

          if (result.error) {
            return;
          }

          onSuccess();
        } catch (error) {}
      } else {
        onSuccess();
      }
    },
    [currentBudgetId, userProfile, budgetsListResponse, budgetFormData, onSuccess],
  );

  const handleRejectBudget = useCallback(
    async (counterProposalValue?: number, counterProposalObs?: string) => {
      if (!currentBudgetId || !userProfile) {
        return;
      }

      if (userProfile === BudgetRecipientEnum.MANAGER) {
        const budgetItem = budgetsListResponse?.budgets.find(
          (item) => item.uuid === currentBudgetId,
        );
        const versionNumber = budgetItem?.lastVersionNumber || 1;
        const finalCounterProposalValue =
          counterProposalValue !== undefined
            ? counterProposalValue
            : budgetFormData?.counterProposalValue;
        const finalCounterProposalObs =
          counterProposalObs !== undefined
            ? counterProposalObs
            : budgetFormData?.counterProposalObs;

        try {
          const result = await rejectBudgetAsManager(
            currentBudgetId,
            versionNumber,
            finalCounterProposalValue,
            finalCounterProposalObs,
          );

          if (result.error) {
            return;
          }

          onSuccess();
        } catch (error) {}
      } else {
        onSuccess();
      }
    },
    [currentBudgetId, userProfile, budgetsListResponse, budgetFormData, onSuccess],
  );

  return {
    handleAcceptBudget,
    handleRejectBudget,
  };
};
